import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=6260e484&scoped=true&"
import script from "./EmployeeForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=6260e484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6260e484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSwitch,VTextField})
